/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutCardsFilled = createReactComponent("filled", "layout-cards-filled", "IconLayoutCardsFilled", [["path", { "d": "M8 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M18 3a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

export { IconLayoutCardsFilled as default };
//# sourceMappingURL=IconLayoutCardsFilled.mjs.map
